














import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  name: 'FBtn'
})
class FBtn extends Vue {
  @Prop() readonly color?: string

  private get btnColor(): string {
    return this.color || 'primary'
  }
}

export default FBtn
